import React from 'react';

export default function About() {
  return (
    <div>
      <h1>About us</h1>
      Lorem ipsum, dolor sit amet consectetur adipisicing elit. Repudiandae
      temporibus ipsa quia magni assumenda voluptate aperiam debitis, voluptas
      sit officiis rerum. Tenetur, magnam accusamus! Sequi sunt ullam qui
      expedita modi.
    </div>
  );
}
